import { combineReducers }  from "redux";
import ReducersNotification from "app/main/store/common/reducers/notification.reducers";
import ReducersComment      from "app/main/store/common/reducers/comment.reducers";

const CommonCombineReducer = combineReducers({
    ReducersNotification,
    ReducersComment,
});

export default CommonCombineReducer;